module.exports = __webpack_public_path__ + "static/media/bedroom.c733dfe4.svg";